import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Step1ProgramType from './Step1ProgramType';
import Step2UserInfo from './Step2UserInfo';
import Step3FitnessGoal from './Step3FitnessGoal';
import Step4HealthInfo from './Step4HealthInfo';
import Step5EquipmentConfirm from './Step5EquipmentConfirm';
import { FaMoon, FaSun } from 'react-icons/fa';

export default function PlanWizard() {
  const [dark, setDark] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();

  const { requestedPlan, planType, price } = location.state || {};

  const [formData, setFormData] = useState({
    RequestedPlan: requestedPlan!= undefined ? requestedPlan :parseInt(localStorage.getItem('freeRequestedPlan')),
    PlanType: planType != undefined ? planType :parseInt(localStorage.getItem('freePlanType')),
    Price: price != undefined ? price :parseInt(localStorage.getItem('freePrice')),
    Age: '',
    Height: '',
    Weight: '',
    Gender: null,
    Goal: null,
    FitnessExperience: null,
    TrainingDaysPerWeek: '',
    ActivityLevel: null,
    Allergies: null,
    MedicalConditions: null,
    EquipmentAccess: null,
  });

  const goNext = () => setCurrentStep((prev) => prev + 1);
  const goBack = () => setCurrentStep((prev) => prev - 1);

  const handleFinalSubmit = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      localStorage.setItem('redirectAfterLogin', '/summary');
      navigate('/login');
      return;
    }
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-8 font-vazir">
                  <a href='/'>
          <img src="/logo.png" alt="logo" className="w-16 h-16 mx-auto mb-4"/>
          </a>
        <div className="max-w-xl mx-auto bg-gray-50 dark:bg-[#1a1d2e] p-6 rounded-xl shadow">
          {currentStep === 1 && <Step1ProgramType formData={formData} setFormData={setFormData} onNext={goNext} />}
          {currentStep === 2 && <Step2UserInfo formData={formData} setFormData={setFormData} onNext={goNext} onBack={goBack} />}
          {currentStep === 3 && <Step3FitnessGoal formData={formData} setFormData={setFormData} onNext={goNext} />}
          {currentStep === 4 && <Step4HealthInfo formData={formData} setFormData={setFormData} onNext={goNext} />}
          {currentStep === 5 && <Step5EquipmentConfirm formData={formData} setFormData={setFormData} onNext={handleFinalSubmit} />}

          <div className="mt-8 flex justify-center gap-6">
            {currentStep === 1 ? (
              <button
                onClick={() => navigate('/plans')}
                className="w-full p-3 rounded-xl border-2 bg-white dark:bg-[#2a2f3b]"
              >
                بازگشت به انتخاب پلن
              </button>
            ) : (
              <button
                onClick={goBack}
                className="w-full p-3 rounded-xl border-2 bg-white dark:bg-[#2a2f3b]"
              >
                مرحله قبل
              </button>
            )}
          </div>
        </div>

        {/* دکمه تغییر تم */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>
      </div>
    </div>
  );
}
